module.exports = __webpack_public_path__ + "static/img/table.304d6f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/table.png
// module id = U3ry
// module chunks = 1